import { render, staticRenderFns } from "./settleUp.vue?vue&type=template&id=bc4e742c&scoped=true&"
import script from "./settleUp.vue?vue&type=script&lang=js&"
export * from "./settleUp.vue?vue&type=script&lang=js&"
import style0 from "./settleUp.vue?vue&type=style&index=0&id=bc4e742c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4e742c",
  null
  
)

component.options.__file = "settleUp.vue"
export default component.exports